/**
 * ShowroomAtmosphere — global, fixed, pointer-none ambient layer.
 *
 * Mounted ONCE at the app root. Provides the dark-gallery feeling on
 * every route without each page needing to re-implement it:
 *   • Top vignette deepening
 *   • Soft warm floor halo (architectural lighting horizon)
 *
 * Pure CSS, GPU-only, respects prefers-reduced-motion.
 */
const ShowroomAtmosphere = () => (
  <div className="showroom-atmosphere" aria-hidden="true" />
);

export default ShowroomAtmosphere;
